import React, { useState } from 'react';
import shortid from 'shortid';
import {
  Row,
  Col,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { scroller, Element } from 'react-scroll';

import LoadMore from 'components/loadMore';
import { Title } from 'components/typography';
import { useMarketData } from 'context/market';

import {
  container,
  reportContainer,
  filterContainer,
  filtersContainer,
  loadMorebutton,
  reportCardContainer,
} from './scss/AnalyticalReport.module.scss';
import {
  transformReports,
  getDropdownOptions,
  filterReports,
  getOptionLabel,
} from './AnalyticalReport.helpers';
import { REPORTS_PER_PAGE, SCROLL_CONFIG, DEFAULT_DROPDOWN_OPTION } from './AnalyticalReport.constants';
import AnalyticalReportCard from './AnalyticalReportCard';

const AnalyticalReport = () => {
  const [pageNumber, setPageNumber] = useState(1);
  const { analyticalReports } = useMarketData();
  const reports = transformReports(analyticalReports);
  const dropdownOptions = getDropdownOptions(analyticalReports);
  const [activeOption, setActiveOption] = useState(DEFAULT_DROPDOWN_OPTION);
  const renderedReports = filterReports(reports, activeOption);
  const loadedReportsCount = pageNumber * REPORTS_PER_PAGE;
  const canLoadMore =
    renderedReports.length && loadedReportsCount < renderedReports.length;

  const loadMorePosts = () => {
    setPageNumber(pageNumber + 1);
    scroller.scrollTo('loadMore', SCROLL_CONFIG);
  };

  const collapsePosts = () => {
    setPageNumber(1);
    scroller.scrollTo('reportsTop', SCROLL_CONFIG);
  };

  return (
    <section className={container}>
      <Row noGutters>
        <Col lg="4">
          <Title size="xl" value="Reports & Documents" />
          <p>
            AFEX reports are created by a team of dedicated researchers who
            study commodity prices across markets, key drivers for commodity
            supply and demand, and trends in the market, distilling and
            arranging all this data to ensure that it makes the most sense to
            the people seeking out information on the market to guide investment
            decisions.
          </p>
        </Col>
        <Col lg="8">
          <div className={filtersContainer}>
            <UncontrolledDropdown>
              <DropdownToggle className={filterContainer} caret>
                {getOptionLabel(activeOption)}
              </DropdownToggle>
              <DropdownMenu>
                {dropdownOptions.map(option => (
                  <DropdownItem
                    key={option}
                    onClick={() => setActiveOption(option)}
                  >
                    {getOptionLabel(option)}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
          <Element name="reportsTop" />
          <Row noGutters>
            {renderedReports.slice(0, loadedReportsCount).map(report => (
              <Col md="6" key={shortid()} className={reportContainer}>
                <div className={reportCardContainer}>
                  <AnalyticalReportCard
                    report={report}
                    frequency={activeOption}
                  />
                </div>
              </Col>
            ))}
          </Row>
          <Element name="loadMore">
            <LoadMore
              isVisible={renderedReports.length > REPORTS_PER_PAGE}
              label={canLoadMore ? 'Load more' : 'Collapse Reports'}
              onClick={canLoadMore ? loadMorePosts : collapsePosts}
              arrowDirection={canLoadMore ? 'down' : 'up'}
              className={loadMorebutton}
            />
          </Element>
        </Col>
      </Row>
    </section>
  );
};

AnalyticalReport.propTypes = {};

AnalyticalReport.defaultProps = {};

export default AnalyticalReport;
